<template>
  <v-app>
    <!-- Navigation Bar -->
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-icon size="large" class="mr-2">mdi-white-balance-sunny</v-icon>
        <router-link to="/" class="text-decoration-none text-white">
          <span class="text-h5 font-weight-bold">SunShadow</span>
        </router-link>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        to="/"
        text
      >
        <v-icon start>mdi-home</v-icon>
        Home
      </v-btn>

      <v-btn
        to="/uvindex"
        text
      >
        <v-icon start>mdi-white-balance-sunny</v-icon>
        UV Monitor
      </v-btn>

      <v-btn
        to="/data"
        text
      >
        <v-icon start>mdi-chart-bar</v-icon>
        UV Statistics
      </v-btn>

      <v-btn
        to="/personal"
        text
      >
        <v-icon start>mdi-account</v-icon>
        Sunscreen Recommendations
      </v-btn>

      <v-btn
        to="/reminder"
        text
      >
        <v-icon start>mdi-bell</v-icon>
        Set Reminder
      </v-btn>

      <v-btn
        to="/clothing"
        text
      >
        <v-icon start>mdi-tshirt-crew</v-icon>
        Protection Guide
      </v-btn>
    </v-app-bar>

    <!-- Mobile Side Navigation -->
    <v-navigation-drawer
      v-model="drawer"
      location="right"
      temporary
    >
      <v-list>
        <v-list-item
          v-for="(item, index) in navItems"
          :key="index"
          :to="item.path"
          :active="$route.path === item.path"
          :prepend-icon="item.icon"
          @click="drawer = false"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Main Content Area -->
    <v-main>
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </v-main>

    <!-- Footer -->
    <v-footer app color="primary" class="text-center d-flex flex-column">
      <div>
        SunShadow
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  setup() {
    const route = useRoute()
    return { route }
  },
  data() {
    return {
      drawer: false,
      navItems: [
        {
          title: 'Home',
          path: '/',
          icon: 'mdi-home'
        },
        {
          title: 'UV Monitor',
          path: '/uvindex',
          icon: 'mdi-white-balance-sunny'
        },
        {
          title: 'UV Statistics',
          path: '/data',
          icon: 'mdi-chart-bar'
        },
        {
          title: 'Sunscreen Recommendations',
          path: '/personal',
          icon: 'mdi-account'
        },
        {
          title: 'Set Reminder',
          path: '/reminder',
          icon: 'mdi-bell'
        },
        {
          title: 'Protection Guide',
          path: '/clothing',
          icon: 'mdi-tshirt-crew'
        }
      ]
    }
  }
}
</script>

<style>
.v-application {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.v-btn {
  text-transform: none !important;
}

.v-app-bar-title {
  width: auto !important;
}

.text-caption {
  line-height: 1.2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
